import axios from "axios";

const endpoint_url = "/message/whatsappMessageTemplate/headerImage";

const uploadHeaderImage = ({
  file,
  templateName,
  imageUrl
}) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('template_name', templateName);
    formData.append('image_url', imageUrl);

    axios
      .post(endpoint_url, formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      )
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response?.data || "An unknown error occurred");
      });
  });
};

export default uploadHeaderImage;
